export default "__VITE_ASSET__DStM3eyu__"